import { useEffect, useState } from 'react';

export const useWorkflowNodesForDisplay = (workflowNodes) => {
  const [workflowNodesForDisplay, setWorkflowNodesForDisplay] = useState([]);

  useEffect(() => {
    setWorkflowNodesForDisplay(
      workflowNodes
        ? workflowNodes.reduce((acc, node) => {
            if (!acc[node.workflow.id]) {
              acc[node.workflow.id] = {
                name: node.workflow.name,
                nodes: [node.id],
              };
            } else {
              acc[node.workflow.id] = {
                ...acc[node.workflow.id],
                nodes: [...acc[node.workflow.id].nodes, node.id],
              };
            }

            return acc;
          }, {})
        : {},
    );
  }, [workflowNodes]);

  return workflowNodesForDisplay;
};
